import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathEqualsCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="math-equals-circle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 10.25C8 9.83579 8.33579 9.5 8.75 9.5H15.25C15.6642 9.5 16 9.83579 16 10.25C16 10.6642 15.6642 11 15.25 11H8.75C8.33579 11 8 10.6642 8 10.25ZM8 13.75C8 13.3358 8.33579 13 8.75 13H15.25C15.6642 13 16 13.3358 16 13.75C16 14.1642 15.6642 14.5 15.25 14.5H8.75C8.33579 14.5 8 14.1642 8 13.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMathEqualsCircle;
